export default "__VITE_ASSET__JyKFT1du__"